import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=22adbec7"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports